import { useSelector } from 'react-redux';
import ExecutionStatus from '@/components/surfaces/ExecutionStatus.jsx';
import { threadExecution } from '@/redux/selectors/pieveSelectors/assistantSelectors.js';

/** Where the latest run stands, right above the composer: its state, what Pieve is doing and what happens next. */
const RunStatus = ({ threadId }) => {
  const execution = useSelector((state) => threadExecution(state, threadId));

  if (!execution) {
    return null;
  }

  return (
    <div className="assistant-run-status" data-state={execution.state} role="status" aria-live="polite">
      <ExecutionStatus state={execution.state} detail={execution.detail} />
      <span className="assistant-run-status__next">{execution.next}</span>
    </div>
  );
};

export default RunStatus;
